(function () {
    'use strict';

    angular.module("imApp").factory("caseService", ['$ihttp', function ($ihttp) {
        var service = {
            getCase: function (parms) {
                return $ihttp.post({
                    method: 2558,
                    parameters: parms || {}
                });
            },
            saveObj: function (setting) {
                return $ihttp.post({
                    method: 2560,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();